import Header from 'hf/Header';
export const ZAWHeader = () => <Header />;

export default ZAWHeader;
